<template>
    <b-card no-body class="bg-secondary-card data" header-tag="h3" :header="$t('general.project.dashboard.hours_total')">
        <span v-if="showTableBarLoader">
            <BarLoader 
                class="my-custom-bar-loader"
                :color="'#6f9fe6'"
            >
            </BarLoader>
        </span>
        <span style="padding: 1.25rem;" v-if="tableLoaded">
            <div class="row" v-if="tableLoaded">
                <div class="col-lg-12 mb-3 mt-3">
                    <b-table hover bordered :fields="hours_total_fields" :items="rowData"></b-table>
                </div>
            </div>
        </span>
    </b-card>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';
import { BarLoader } from '@saeris/vue-spinners';

export default {
    name: 'project_hours_total',
    components: {
        notificationIcons,
        BarLoader,
    },
    data() {
        return {
            tableLoaded: false,
            showTableBarLoader: false,
            rowData: [],
            hours_total_fields: {
                current_total_hours: {
                    label: Vue.i18n.translate('table.current_total_hours'),
                },
                title: {
                    label: Vue.i18n.translate('table.title'),
                },
                percent_from_total_hours: {
                    tdClass: 'italicAndBoldCustomClass',
                    label: Vue.i18n.translate('table.percent_from_total_hours'),
                }
            }
        }
    },
    mounted() {
        this.onLoadTable();
    },
    methods: {
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        onLoadTable () {
            this.showTableBarLoader = true;
            let data = http.route('project/'+this.$route.params.id+'/project_hours_total').get();
            data.then(response => {
                if (!response.isError && typeof response.data != 'undefined') {
                    var data = response.data;
                    data.forEach(field => {
                        if (typeof field.title != 'undefined' && field.title == 'table.total_hours') {
                            field.title = Vue.i18n.translate(field.title);
                        }
                    });
                    this.rowData = data;
                    this.tableLoaded = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }

                this.showTableBarLoader = false;
            });
        },
        italicAndBoldCustomClass(value) {
            if (value === 'NULL') {
                return 'font-italic font-weight-bold';
            }
        },
    }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/pages/project/project_progress_reporting/project_hours_total.vue